import { cva, type VariantProps } from 'class-variance-authority'

export const dialogVariants = cva(
    // CDK overlay handles centering via centerHorizontally/centerVertically position strategy.
    // No padding here - content components manage their own layout.
    'relative z-[9999] flex flex-col w-full max-h-[90vh] bg-white shadow-xl rounded-xl overflow-hidden',
)
export type ZardDialogVariants = VariantProps<typeof dialogVariants>
